import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CustomerDisplayOrder } from "../../Interfaces/Orders";
import config from "../../config";
import OrderContentsTable from "../../components/OrderContentDisplay/OrderContentsTable";
import { decodeQueryParameter } from "../../CommonFunctions";
import ShippingDisplay from "../../components/OrderContentDisplay/ShippingDisplay";

const OrderDisplayPage = () => {
  const decoded = decodeQueryParameter(useParams().orderID || "");
  const cleanOrderID = decoded.order_id;
  const [orderDetails, setOrderDetails] = useState<CustomerDisplayOrder | null>(
    null,
  );
  const [fetchError, setFetchError] = useState<string | null>(null);

  useEffect(() => {
    document.title = "Order Details";
  }, []);
  
  useEffect(() => {
    if (!cleanOrderID) {
      setFetchError("Invalid order link.");
      return;
    }

    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}orders/customer-display/${cleanOrderID}/`,
        );
        if (!response.ok) {
          throw new Error("Order not found.");
        }
        const data: CustomerDisplayOrder = await response.json();
        setOrderDetails(data);
      } catch (error) {
        setFetchError("Could not load order details.");
      }
    };
    fetchOrderDetails();

  }, [cleanOrderID]);

  if (fetchError) {
    return <div><p>{fetchError}</p></div>;
  }

  return (
    orderDetails && (
      <div>
        <h2>Hello, {orderDetails.customer_name}</h2>{" "}
        <h3>Order #{orderDetails.order_id}</h3>
        <OrderContentsTable order={orderDetails} />
        <ShippingDisplay order_details={orderDetails} />
      </div>
    )
  );
};
export default OrderDisplayPage;
